import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import "./styles/reset.css";
import router from "./router";

Vue.config.productionTip = false;

Vue.use(ElementUI);

Vue.filter("miniValue", function (value) {
  if (value === null || value === undefined || value === "") return "--";
  if (!value) return value;
  const num = Number(value);
  if (num && num > 10000) {
    return (num / 10000).toFixed(2);
  }
  return value;
});

Vue.filter("numUnit", function (value, unit = "kWh") {
  if (!value) return unit;
  const num = Number(value);
  if (num && num > 10000) {
    return "万" + unit;
  }
  return unit;
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
